angular.module('manufacturing')
    .component('manufacturingOrderAcceptance', {
        bindings: {
            orderId: '<',
            resource: '@',
            acceptance: '<',
            status: '<',
            locationId: '<',
        },
        template: `
            <div class="well well-sm text-warning bold manufacturing-order-acceptance" ng-if="$ctrl.canSave === false">Brak uprawnień do oddziału <i class="fa fa-fw fa-question-circle" uib-tooltip="Akceptacja przez oddział możliwa tylko przez pracowników/kierownika oddziału"></i></div>
            <div ng-if="$ctrl.isWaitingForAcceptance && $ctrl.canSave" class="manufacturing-order-acceptance">
                <section class="panel panel-default no-padding-bottom">
                    <div class="panel-heading">
                        <div class="title">
                            <span class="text-danger">Wymagane potwierdzenie przez oddział</span>
                        </div>
                        <div class="action-buttons">
                            <button type="button" class="btn btn-xs btn-success" ng-click="$ctrl.accept()">Potwiedź</button>
                            <button type="button" class="btn btn-xs btn-danger" ng-click="$ctrl.reject()">Odrzuć</button>
                        </div>
                    </div>
                </section>
            </div>
        `,
        controller: function ($q, $rootScope, ManufacturingOrder, VehicleLocation, Principal) {
            this.$onChanges = () => {
                let $principal = Principal.currentUser();
                let $location = VehicleLocation.get({id: this.locationId}).$promise;

                $q.all([$principal, $location])
                    .then(([currentUser, item]) => {
                        let isUser = item.users.some(u => u.id === currentUser.id);
                        let isManager = item.managers.some(u => u.id === currentUser.id);
                        this.canSave = isUser || isManager;
                    })
                this.isWaitingForAcceptance = this.acceptance?.status === "PENDING" && this.acceptance?.required === true
            }

            this.accept = () => {
                return ManufacturingOrder.acceptance({id: this.orderId, resource: this.resource, status: "ACCEPTED"}).$promise
                    .then(() => $rootScope.$broadcast('manufacturing-order.updated'))
            }

            this.reject = () => {
                return ManufacturingOrder.acceptance({id: this.orderId, resource: this.resource, status: "REJECTED"}).$promise
                    .then(() => $rootScope.$broadcast('manufacturing-order.updated'))
            }
        }
    })

    .component('manufacturingOrderAcceptanceLabel', {
        bindings: {
            status: '<',
        },
        template: `
            <span ng-if="$ctrl.status != null" class="label manufacturing-order-acceptance {{$ctrl.status}}">{{'manufacturing-order.acceptance.status.' + $ctrl.status | translate}}</span>
        `
    })
